module.exports = __webpack_public_path__ + "static/img/oldLogo.e3f5773.png";


//////////////////
// WEBPACK FOOTER
// ./static/oldLogo.png
// module id = MZCR
// module chunks = 1